import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { HeaderDropdown } from './index';
import {
  selectedProductState,
  productsListSelector,
  userPreferencesSelector,
  tradeContractTypeSelector,
} from 'selectors';
import { isAuthenticated, updateUserPreference } from 'actions/user';

const mapStateToProps = state => {
  return {
    productsList: productsListSelector(state),
    selected_product: selectedProductState(state),
    userPreferences: userPreferencesSelector(state),
    userId: state.user.id,
    tradeContractType: tradeContractTypeSelector(state),
    isLoggedIn: isAuthenticated(state.user),
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ updateUserPreference }, dispatch);

export const HeaderDropDownContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderDropdown);
